import { render } from "./signup-form.vue?vue&type=template&id=c3a705a4"
import script from "./signup-form.vue?vue&type=script&lang=js"
export * from "./signup-form.vue?vue&type=script&lang=js"

import "./signup-form.vue?vue&type=style&index=0&id=c3a705a4&lang=scss"

import exportComponent from "/Users/ashley.eastham/Fostr Dev/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__